<!-- <cv-module-custom-setting-section *ngIf="moduleManager.settingsView === 'slideout'" [moduleManager]="moduleManager">
    <div class="custom-setting-section-title">
        <span cvLocalizedText langSection="Queue-Counter" langKey="CallBack_In_Queue">CallBack/In-Queue</span>
    </div>
    <div class="custom-setting-section-context">{{ setContext() }}</div>
    <div class="custom-setting-section-body">
        <div>
            <input type="radio" id="both_{{moduleKey}}" value="both" name="queue-counter-choice-{{moduleKey}}" class="form-control-check my-0 mx-2 p-0" [(ngModel)]="choice">
            <label for="both_{{moduleKey}}" cvLocalizedText langSection="Queue_Counter" langKey="Longest_Delay_Both">Longest Delay InQueue and Callback</label>
        </div> 
        <div>
            <input type="radio" id="inqueue_{{moduleKey}}" value="inqueue" name="queue-counter-choice-{{moduleKey}}" class="form-control-check my-0 mx-2 p-0" [(ngModel)]="choice">     
            <label for="inqueue_{{moduleKey}}" cvLocalizedText langSection="Queue_Counter" langKey="Longest_Delay_In_Queue">Longest Delay InQueue</label>
        </div>
        <div>
            <input type="radio" id="callback_{{moduleKey}}" value="callback" name="queue-counter-choice-{{moduleKey}}" class="form-control-check my-0 mx-2 p-0" [(ngModel)]="choice">     
            <label for="callback_{{moduleKey}}" cvLocalizedText langSection="Queue_Counter" langKey="Longest_Delay_Callback">Longest Delay Callback</label>
        </div>
    </div>
</cv-module-custom-setting-section> -->

<!-- <ng-container *ngIf="moduleManager.settingsView === 'modal'">
    <div cvModuleLegacyCustomSettingSection position="bottom" [moduleManager]="moduleManager">
        <div>
            <input type="radio" id="both_{{moduleKey}}" value="both" name="queue-counter-choice-{{moduleKey}}" class="form-control-check my-0 mx-2 p-0" [(ngModel)]="choice">
            <label for="both_{{moduleKey}}" cvLocalizedText langSection="Queue_Counter" langKey="Longest_Delay_Both">Longest Delay InQueue and Callback</label>
        </div> 
        <div>
            <input type="radio" id="inqueue_{{moduleKey}}" value="inqueue" name="queue-counter-choice-{{moduleKey}}" class="form-control-check my-0 mx-2 p-0" [(ngModel)]="choice">     
            <label for="inqueue_{{moduleKey}}" cvLocalizedText langSection="Queue_Counter" langKey="Longest_Delay_In_Queue">Longest Delay InQueue</label>
        </div>
        <div>
            <input type="radio" id="callback_{{moduleKey}}" value="callback" name="queue-counter-choice-{{moduleKey}}" class="form-control-check my-0 mx-2 p-0" [(ngModel)]="choice">     
            <label for="callback_{{moduleKey}}" cvLocalizedText langSection="Queue_Counter" langKey="Longest_Delay_Callback">Longest Delay Callback</label>
        </div>
    </div>
</ng-container> -->

<ng-container *ngIf="moduleManager.settingsView === 'cxOneModal'">
    <div cvModuleCxoneCustomSettingSection [moduleManager]="moduleManager">
        <div class="radioButtons">
            <div>
                <input type="radio" id="both_{{moduleKey}}" value="both" name="queue-counter-choice-{{moduleKey}}" class="form-control-check my-0 mr-2 p-0" [(ngModel)]="choice">
                <label for="both_{{moduleKey}}" class="sentenceCase" cvLocalizedText langSection="Queue_Counter" langKey="Longest_Delay_Both">Longest Delay InQueue and Callback</label>
            </div> 
            <div>
                <input type="radio" id="inqueue_{{moduleKey}}" value="inqueue" name="queue-counter-choice-{{moduleKey}}" class="form-control-check my-0 mr-2 p-0" [(ngModel)]="choice">     
                <label for="inqueue_{{moduleKey}}" class="sentenceCase" cvLocalizedText langSection="Queue_Counter" langKey="Longest_Delay_In_Queue">Longest Delay InQueue</label>
            </div>
            <div>
                <input type="radio" id="callback_{{moduleKey}}" value="callback" name="queue-counter-choice-{{moduleKey}}" class="form-control-check my-0 mr-2 p-0" [(ngModel)]="choice">     
                <label for="callback_{{moduleKey}}" class="sentenceCase" cvLocalizedText langSection="Queue_Counter" langKey="Longest_Delay_Callback">Longest Delay Callback</label>
            </div>
        </div>
    </div>
</ng-container>

